var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('LoadingContainer'):_c('ListPanel',{attrs:{"users":_vm.users,"content-article-categories":_vm.contentArticleCategories,"portal":_vm.portal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }